import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { ReactComponent as DNAIcon } from '../assets/icons/dna-icon.svg';
import { ReactComponent as ExploreArrow } from '../assets/icons/double-arrow.svg';
import SmallBanner from '../components/smallBanner';
// import BlogImg1 from '../assets/Images/blog1.png';
// import BlogImg2 from '../assets/Images/blog2.jpg';
// import BlogImg3 from '../assets/Images/blog3.jpg';
import axios from "axios";
import { BASE_URL, GET_BLOG} from "../ApiUrl";


const Blogs = () => {

    const [blogs, setBlogs] = useState([]);

    const navigate = useNavigate();

    const fetchBlogs = async () => {
        try {
            const result = await axios.get(BASE_URL + GET_BLOG);
            setBlogs(result.data.blog);
        } catch (error) {
            console.error('Error fetching blogs:', error);
        }
    };

    useEffect(() => {
        fetchBlogs();
    }, []);


    // console.log(blogs, "blogsblogs");

    const handleviewblog = (value) => {
        navigate(`/blogView?uuid=${value.uuid}`);
    };


    return (
        <main className="blogs-page">
            <SmallBanner Heading={'Our Blogs'} />

            <section className="blogs-wrapper py-100">
                <div className="container">
                    <div className="row justify-content-center mb-lg-5 mb-4" data-aos="fade-up" data-aos-duration="3000">
                        <div className="col-lg-7 text-center">
                            <div className="banner-subtitle secondary-text"><DNAIcon className="" />Our Blogs</div>
                            <h2 className='section-title my-sm-2 my-0'>News & Articles From Avna</h2>
                            <p className='para-text my-3 col-md-8 mx-auto'>Specializing in exporting pharmaceuticals, nutraceuticals, and ayurvedic products with a strong focus on quality.</p>
                        </div>
                    </div>
                    <div className="row">
                        {blogs && blogs.length > 0 ? blogs.map((value, index) => {
                            return (
                                <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                                    <div onClick={() => handleviewblog(value)} className="blog-card">
                                        <div className="top">
                                            <img src={BASE_URL + value.image} alt="Blog" className="blog-img w-100" />
                                            <h3 className="blog-title">{value.title.substring(0, 60)}</h3>
                                        </div>
                                        <button className="blog-link">Read more <span><ExploreArrow className="next-icon" /> </span></button>
                                    </div>
                                </div>
                            );
                        }) : (
                            <div>
                                <p className="text-center">No Blog  available</p>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </main>
    );
};
export default Blogs;


